import {useFieldArray} from "react-hook-form";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {removeOrderFormProduct} from "../../../../store/slices/orderSlice";
import {checkFeatureAvailability, noImagePlaceholder, unstructureJson} from "../../../../util/helper";
import ProductQuantityAction from "./ProductQuantityAction";
import {useParams} from "react-router-dom";

const OrderProductList = ({ setValue, register, errors, getValues, control, watch}) => {
  const params = useParams()
  const { fields:productFields, append, remove} = useFieldArray({
    control,
    name: 'products',
  });
  const [productErrors, setProductErrors] = useState(false)
  const products = useSelector(state => state.orders.orderForm.products);
  const order = useSelector(state => state.orders.orderForm);
  const dispatch = useDispatch()


  const newErrors = Object.keys(errors).map((key) =>  key);

  useEffect(()=>{
    setProductErrors(false)
  }, [products])

  useEffect(()=>{
     if(newErrors && newErrors.includes('products') && !products.length){
       setProductErrors(true)
     }
  }, [newErrors])

  return (
    <>
      <div className="view_order_details">
        {productErrors && <span className={'text_red'}>Please select Product</span>}
      <div className="img_wrap">
        {products && products.map((product, i)=>(
        <div className="inner p_relative" key={'product_'+i}>
          <div className="inner_wrap">
            <img src={product.url} width={100} alt="" onError={noImagePlaceholder} />
              <div className="text">
               {checkFeatureAvailability(order, 'add-product', params) &&
                <ProductQuantityAction product={product} index={i}/>
                }
                {product.sku && <h2 className={"mt_5"}>{product.sku}</h2>}
                <p>Unit Price:${product.price.toFixed(2)}</p>
                <p>Qty: {product.quantity}</p>
                <p>Total price: ${(product.price * product.quantity) .toFixed(2)}</p>
                {product.product_variant_values && <p>
                  { unstructureJson(product.product_variant_values)}
                </p>}
               {checkFeatureAvailability(order, 'add-product', params) &&
                <div className="delete_btn p_absolute t_0 mr_5 r_0">
                  <button type={"button"} className="btn btn_danger"
                          onClick={() => dispatch(removeOrderFormProduct(product))}><i className="fas fa-trash-alt"></i>
                  </button>
                </div>
                }
              </div>
          </div>
        </div>))
        }
      </div>
      </div>
    </>
);
}

export default OrderProductList